<div class="invoices-overview">
  <div class="invoices-overview__summary invoices-overview__panel">
    <app-total-amount [amount]="dataContext.totalAmount" [rounding]="dataContext.totalRounding"></app-total-amount>
    <div class="invoices-overview__divider">
      <app-invoice-count [number]="dataContext.numberOfInvoices"></app-invoice-count>
    </div>
    <div class="invoices-overview__divider">
      <app-lease-agreement-count [number]="dataContext.concernedLeaseAgreements"></app-lease-agreement-count>
    </div>
  </div>
  <div class="invoices-overview__panel invoices-overview__categories">
    <div class="title">{{ 'INVOICE.SUMMARY_PER_LEASE_AGREEMENT_CATEGORY' | translate }}</div>
    @if (dataContext?.dwellingTotalAmount?.amount > 0) {
      <app-category-invoice-amount
        [amount]="dataContext.dwellingTotalAmount"
        [category]="dwelling"
        [totalAmount]="dataContext.totalAmount"
      ></app-category-invoice-amount>
    }
    @if (dataContext?.cooperativeHousingTotalAmount?.amount > 0) {
      <app-category-invoice-amount
        [amount]="dataContext.cooperativeHousingTotalAmount"
        [category]="cooperativeHousing"
        [totalAmount]="dataContext.totalAmount"
      ></app-category-invoice-amount>
    }
    @if (dataContext?.blockTotalAmount?.amount > 0) {
      <app-category-invoice-amount
        [amount]="dataContext.blockTotalAmount"
        [category]="block"
        [totalAmount]="dataContext.totalAmount"
      ></app-category-invoice-amount>
    }
    @if (dataContext?.parkingTotalAmount?.amount > 0) {
      <app-category-invoice-amount
        [amount]="dataContext.parkingTotalAmount"
        [category]="parking"
        [totalAmount]="dataContext.totalAmount"
      ></app-category-invoice-amount>
    }
    @if (dataContext?.premisesTotalAmount?.amount > 0) {
      <app-category-invoice-amount
        [amount]="dataContext.premisesTotalAmount"
        [category]="premises"
        [totalAmount]="dataContext.totalAmount"
      ></app-category-invoice-amount>
    }
    @if (dataContext?.otherTotalAmount?.amount > 0) {
      <app-category-invoice-amount
        [amount]="dataContext.otherTotalAmount"
        [category]="other"
        [totalAmount]="dataContext.totalAmount"
      ></app-category-invoice-amount>
    }
  </div>
  <div class="invoices-overview__panel">
    <app-article-invoice-amount [articles]="dataContext.articleAmounts"></app-article-invoice-amount>
  </div>
</div>
